import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  checkboxCell: {
    minWidth: '67px'
  },
  cell: {
    width: '25%'
  }
});
